















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Step extends Vue {
  @Prop({ default: 0 }) readonly current!: number;
  items = [
    {
      label: "Ospiti",
      step: 0,
    },
    {
      label: "Sesso",
      step: 1,
    },
    {
      label: "Resp. acquisti",
      step: 2,
    },
    {
      label: "Figli",
      step: 3,
    },
    {
      label: "Età",
      step: 4,
    },
  ];

  itemClass(item: { label: string; step: number }) {
    if (item.step < this.current) {
      return "visited";
    }
    if (item.step > this.current) {
      return "";
    }
    return "active";
  }
}
